import { render, staticRenderFns } from "./CalendarDash.vue?vue&type=template&id=52eb4ab4&"
import script from "./CalendarDash.vue?vue&type=script&lang=js&"
export * from "./CalendarDash.vue?vue&type=script&lang=js&"
import style0 from "./CalendarDash.vue?vue&type=style&index=0&id=52eb4ab4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports